import m from "../../prime-src/prepare";
import { useEffect, useRef } from "react";
import $ from 'jquery';

export default function HeadPlay() {
  const pc = useRef(null);

  function initialEffect() {
    $(pc.current).on("click", function () {
      m.togglePosition(pc.current);
    });
  }

  useEffect(() => {
    initialEffect();
  }, []);

  return (
    <main className="side2" id="headPlay">
      <div style={{fontSize:'.8em'}}>When you just listen to music without seeing videos, to save data transfer fee and battery, hide list play with the below toggle button.</div>
      <div className="numbers-of-recos" id="numbers-of-recos0"></div>
      <a id="out-focus" style={{display:'none'}}>out-focus</a>
      <div className="button enabled" id="toggle-reco-list-play" onClick={() => m.fsToRs.toggleRecoListPlay()}>▼ Showing reco list play
      </div>
      <div id="playlist-container">
        <div id="uri-rendered-container">
          <div id="eveElse-container">
            <div id="eveElse"></div>
          </div>
          <div className="rC" id="rC-youtube-container">
            <div className="rSC">
              <div id="youtube-player"></div>
            </div>
            <div className="pc"><span ref={pc}>▲ click me to stick to the left top (fixed position)</span>
            </div>
          </div>
        </div>
        <div id="headPlay-buttons"></div>
        <div id="reco-playing"></div>
      </div>
    </main>
  );
}
